import React from 'react';

const CgmToolTip = () => {
    return (
        <>
            <ul className="tooltip-contents">
                <li>
                    <em className="tit">허가번호</em>
                    <span className="desc">수허 23-397호</span>
                </li>
                <li>
                    <em className="tit">품목명</em>
                    <span className="desc">개인용체내연속혈당측정시스템​</span>
                </li>
                <li>
                    <em className="tit">모델명</em>
                    <span className="desc">FreeStyle Libre 2</span>
                </li>
                <li>
                    <em className="tit">수입업자</em>
                    <span className="desc">한국애보트(유)</span>
                </li>
                <li>
                    <em className="tit">제품명</em>
                    <span className="desc">프리스타일 리브레 2 연속 당 측정 시스템(FreeStyle Libre 2 Flash Glucose Monitoring System)</span>
                </li>
                <li>
                    <em className="tit">의료기기 표준코드(UDI)</em>
                    <span className="desc">05021791003785</span>
                </li>
            </ul>
            <p className="notice">
                <span>이 제품은 "일회용 의료 기기"입니다. "재사용 금지"</span>
            </p>
        </>
    )
}

export default CgmToolTip;